import React from "react";

export default function OutcomesSection({ data, onOpenContact }) {
  return (
    <section className="enthusiasm-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="enthusiasm-content">
              <h3 className="heading text-center">{data.title}</h3>
            </div>
          </div>
          {data.items.map((item) => (
            <div
              className={`col-lg-3 col-sm-6 wow animate__animated ${item.animation}`}
              data-wow-delay={item.delay}
              data-wow-duration="1.5s"
              key={item.label}
            >
              <div className="outcome-top">
                <p>{item.label}</p>
                <span className={`icon-box ${item.theme}-bg`}>
                  <img src={item.icon} alt="Outcome Icon" />
                </span>
              </div>
              <div className={`enthusiasm-box ${item.theme}-border`}>
                <p className="box-main-title">{item.title}</p>
                <span className="down-arrow"><i className="fa-solid fa-arrow-down" /></span>
                <p className="box-title">{item.result}</p>
              </div>
            </div>
          ))}
          <div className="btn-wrapper">
            <button type="button" onClick={onOpenContact} className="default-btn">
              {data.button}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
